export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/assuranceIcon.75134ba3.svg","height":62,"width":62,"blurWidth":0,"blurHeight":0};